"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.freezeDeep = void 0;

var _is = require("./is");

var _toTypeString = require("./to-type-string");

const freezeDeepObject = obj => {
  const shallow = { ...obj
  };

  for (const name of Object.getOwnPropertyNames(shallow)) {
    const value = shallow[name];

    if ((0, _is.isObject)(value)) {
      shallow[name] = freezeDeepObject(value);
    } else if ((0, _is.isArray)(value)) {
      shallow[name] = freezeDeepArray(value);
    }
  }

  return Object.freeze(shallow);
};

const freezeDeepArray = arr => {
  const shallow = arr.map(value => {
    if ((0, _is.isObject)(value)) {
      return freezeDeepObject(value);
    } else if ((0, _is.isArray)(value)) {
      return freezeDeepArray(value);
    }
  });
  return Object.freeze(shallow);
};

const freezeDeep = objectOrArray => {
  if ((0, _is.isObject)(objectOrArray)) {
    return freezeDeepObject(objectOrArray);
  }

  if ((0, _is.isArray)(objectOrArray)) {
    return freezeDeepArray(objectOrArray);
  }

  throw new TypeError(`"deepFreeze" expects an instance of Object or Array, but was given "${(0, _toTypeString.toTypeString)(objectOrArray)}"`);
};

exports.freezeDeep = freezeDeep;